import { Component, Input, OnInit, Output } from '@angular/core';
import { FileItem, FileUploader, ParsedResponseHeaders } from 'ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import { SessionTokenService } from '../../../../session/service/session-token';
import { HttpConfig } from '../../../http/config';
import { Subject } from 'rxjs';

@Component({
  selector: 'multi-upload',
  templateUrl: './multi-upload.component.html',
  styleUrls: [ './multi-upload.component.scss' ]
})
export class MultiUploadComponent implements OnInit {

  protected progress: number = 0;
  protected uploader: FileUploader;
  protected hasBaseDropZoneOver: boolean = false;
  protected preview: any[] = [];

  /**
   * Notify observer that upload of all files has been finished
   * @type {Subject<any>}
   */
  @Output('allResultChannel') allResultChannel: Subject<any> = new Subject<any>();
  /**
   * Notify observer that upload of single file has been finished
   * @type {Subject<any>}
   */
  @Output('itemResultChannel') itemResultChannel: Subject<any> = new Subject<any>();
  /**
   * Channel used to start uploading from outside
   */
  @Input() triggerChannel: Subject<any>;
  @Input() relatedTo: string;
  @Input() type: string;
  @Input() url: string;
  @Input() customClass: string;
  @Input() hint: string = '';
  @Input() label: string;
  @Input() currentCount: number = 0;
  @Input() limit: number = 1;

  constructor(private sessionTokenService: SessionTokenService,
              private config: HttpConfig,
              private toastr: ToastrService) {

  }

  ngOnInit(): void {
    this.uploader = new FileUploader({
      url: this.config.baseUri + this.url,
      authToken: this.config.authorization.tokenPrefix + ' ' + this.sessionTokenService.getToken().token,
    });

    this.uploader.onProgressAll = (progress: any) => {
      this.progress = progress;
    };
    this.uploader.onCompleteAll = () => {
      this.uploader.clearQueue();

      this.allResultChannel.next(true);
      this.progress = 0;
    };
    this.uploader.onCompleteItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      this.uploader.removeFromQueue(item);
      this.preview = this.preview.filter((p: any) => {
        return (p.file.name !== item.file.name);
      });

      this.itemResultChannel.next(JSON.parse(response));
    };
    this.uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
    this.uploader.onErrorItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      const error = JSON.parse(response);
      this.toastr.error(error.message || 'Upload error');
      this.uploader.removeFromQueue(item);

      this.preview = this.preview.filter((p: any) => {
        return (p.file.name !== item.file.name);
      });
    };

    this.uploader.options.additionalParameter = { relatedTo: this.relatedTo, type: this.type };

    if (this.triggerChannel instanceof Subject) {
      this.triggerChannel.subscribe(
        (event: any) => {
          this.uploader.options.additionalParameter = {
            ...this.uploader.options.additionalParameter,
            ...event
          };
          if (this.uploader.queue.length === 0) {
            this.allResultChannel.next(true);
          } else {
            this.uploader.uploadAll();
          }
        }
      );
    }
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  fileDropped(fileList: any[]): void {
    fileList = Array.prototype.slice.call(fileList);
    this.appendFiles(fileList.slice(0, this.limit - (this.currentCount + this.uploader.queue.length)));
  }

  fileSelected(fileList: any[]): void {
    fileList = Array.prototype.slice.call(fileList);
    this.appendFiles(fileList.slice(0, this.limit - (this.currentCount + this.uploader.queue.length)));
  }

  appendFiles(fileList: any[]): void {
    if (this.type === 'image') {
      if (typeof FileReader !== 'undefined') {
        Object.values(fileList).forEach((file: File) => {
          const fileReader = new FileReader();
          fileReader.onload = (e: any) => {
            this.preview.push({ file: file, src: e.target.result });
          };
          fileReader.readAsDataURL(file);
        });
      }
    }
  }
}
